export default "<font-face></font-face>\n<router-outlet *ngIf=\"initPage\" ></router-outlet>\n"